'use strict';

angular.module('ClinicApp').directive('appointmentListEmpty', function($state) {
  return {
    templateUrl: '/views/directives/_appointment-list-empty.html',
    scope: {
      modelType: '=',
    },
    link: function($scope) {

      $scope.gotoAvailability = function() {
        $state.go($scope.modelType + '.schedule');
      };

    },
  };
});
